import { useCallback, useEffect, useState } from 'react';
import { clampSlideIndex } from './presentationSlides';

export function usePresentationSlides(slides, initialIndex = 0) {
  const list = Array.isArray(slides) ? slides : [];
  const total = list.length;
  const [index, setIndex] = useState(() => clampSlideIndex(initialIndex, total));

  useEffect(() => {
    setIndex((current) => clampSlideIndex(current, total));
  }, [total]);

  const goPrev = useCallback(() => {
    setIndex((current) => (current > 0 ? current - 1 : current));
  }, []);

  const goNext = useCallback(() => {
    setIndex((current) => (current < total - 1 ? current + 1 : current));
  }, [total]);

  const goFirst = useCallback(() => setIndex(0), []);
  const goLast = useCallback(() => setIndex(total > 0 ? total - 1 : 0), [total]);

  const safeIndex = clampSlideIndex(index, total);
  const current = total > 0 ? list[safeIndex] : null;
  const next = total > 1 && safeIndex < total - 1 ? list[safeIndex + 1] : null;

  return {
    current,
    goFirst,
    goLast,
    goNext,
    goPrev,
    index: safeIndex,
    next,
    setIndex,
    total,
  };
}
